/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-ignore

import React, { useState, useEffect } from 'react';
import { TimelineDetailModal } from '../TimeLineDetailModal';
import { IMultiColListProps } from '../TimeLineDetailModal/MultiColList';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import { useTheme } from '../../../../providers/theme';

import './styles.css';

const moment = require('moment');

export interface ICalendarProps {
  timeZone?: string;
  initialDate?: string;
  initialView?:
    | 'timeGridWeek'
    | 'timeGridDay'
    | 'timeGrid'
    | 'dayGridMonth'
    | 'dayGridWeek'
    | 'dayGrid';
  visibleRange?: {
    start: Date;
    end: Date;
  };
  events: {
    id: string;
    title?: string;
    date: Date;
    data?: IMultiColListProps;
  }[];
  onCalendarChange?(title: string): void;
  onViewMoreClick(id: string): void;
}

export const CalendarComp = (props: ICalendarProps) => {
  const theme = useTheme();
  const {
    events,
    timeZone,
    initialDate,
    initialView,
    visibleRange,
    onCalendarChange,
  } = props;
  const [currentMonth, setCurrentMonth] = useState<string>(
    moment()?.format('MMMM YYYY')
  );
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalId, setModalId] = useState();

  // console.log('current month', currentMonth);

  const onEventChange = (props: any) => {
    console.log('current month calender', props?.view?.title);
    if (props?.view?.title !== currentMonth) {
      onCalendarChange && onCalendarChange(props?.view?.title);
    }
    setCurrentMonth(props?.view?.title);
  };

  const onEventClick = (props: any) => {
    console.log(`event details`, props?.event);
    const {
      event: { id, title, start, end },
    } = props;

    if (!showModal) {
      setModalId(id);
      setShowModal(true);
    }
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(!showModal);
    }
  };

  const _renderModal = () => {
    const found: any = events?.find((e: any) => e.id === modalId);
    console.log(`found data`, found);
    if (showModal && found) {
      return (
        <TimelineDetailModal
          size={'lg'}
          showModal={showModal}
          onDeny={onModalClose}
          modalTitle={found?.title}
          data={found?.data}
          onViewMoreClick={props?.onViewMoreClick}
        />
      );
    }
  };

  return (
    <>
      <FullCalendar
        timeZone={timeZone}
        initialDate={initialDate || undefined}
        height={300}
        contentHeight={'auto'}
        plugins={[dayGridPlugin]}
        initialView={initialView}
        validRange={visibleRange}
        events={events}
        eventClick={onEventClick}
        themeSystem="bootstrap"
        datesSet={onEventChange}
        // eventContent={(info)=><EventContent info={info} events={events}/>}
        //  eventBackgroundColor={theme?.colors?.secondary}
      />
      {_renderModal()}
    </>
  );
};

const EventContent = ({ info, events }: any) => {
  const _getBackgroundColor = (type: string) => {
    switch (type) {
      case 'cyclone':
        return 'red';
      default:
        return 'green';
    }
  };
  console.log('info', info);
  const { event } = info;
  console.log('event id', event?.id);
  const found: any = events?.find((e: any) => e.id === event?.id);
  console.log('found in Content', found);
  return (
    <div style={{ backgroundColor: _getBackgroundColor(found?.type) }}>
      <span>{event?.title}</span>
    </div>
  );
};

CalendarComp.defaultProps = {
  events: [],
  timeZone: 'Asia/Kolkata',
  initialView: 'dayGridMonth',
  visibleRange: {
    start: '2023-01-01',
    end: '2027-12-31',
  },
};
